var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-wrapper"},[(_vm.seminar)?_c('div',[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.seminar.DATA[_vm.id].NAME)}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.decodeHtml(_vm.seminar.DATA[_vm.id].DETAIL_TEXT))}})]):_vm._e(),(_vm.fetching)?_c('c-loading-overlay'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }